import { render } from "./CampaignPaymentListForm.vue?vue&type=template&id=28761224&lang=true"
import script from "./CampaignPaymentListForm.vue?vue&type=script&lang=js"
export * from "./CampaignPaymentListForm.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__